module.exports = require("@mui/x-license");